import { defineComponent as r, computed as l, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as d, createCommentVNode as h, normalizeStyle as f } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "17d04f78-0382-4ce3-93a8-06725f464a77" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#17d04f78-0382-4ce3-93a8-06725f464a77)" }, p = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "m0 144.7 255.3-36.5L512 144.7v222.6L250.5 407 0 367.3z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 0h512v144.7H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M0 367.3h512V512H0z"
}, null, -1), z = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M211.5 323h89v-38l-17.8 9-26.7-26.9-26.7 26.7-17.8-8.9zm-51-44.6 4.2 12.7H178l-10.9 8 4.2 12.7-10.9-8-10.8 8 4.1-12.8-10.7-7.9h13.4zm12.9-44.6 4.1 12.8H191l-10.8 8 4.1 12.6-10.8-7.9-10.9 8 4.2-12.8-10.9-8h13.4zm36.7-33.4 4.2 12.8h13.4l-10.9 8 4.2 12.6-11-7.7-10.8 7.8 4.1-12.7-10.8-7.9H206zm141.4 78-4.2 12.7H334l10.9 8-4.2 12.7 10.9-8 10.8 8-4.1-12.8 10.7-7.9h-13.4zm-12.9-44.6-4.1 12.8H321l10.8 8-4.1 12.6 10.8-7.9 10.9 8-4.2-12.8 10.9-8h-13.4zM302 200.4l-4.2 12.8h-13.4l10.9 8-4.2 12.6 10.9-7.7 10.8 7.8-4.1-12.7 10.8-7.9H306zm-46-16.6 4.1 12.7h13.5l-10.9 8 4.1 12.6-10.8-7.8-10.8 7.8 4.1-12.7-10.9-7.9H252z"
}, null, -1), H = { fill: "none" }, x = ["r"], B = /* @__PURE__ */ r({
  __name: "tj",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const t = a, o = l(() => 512 + 2 * t.strokeWidth), s = l(() => -t.strokeWidth), n = l(() => 256 + t.strokeWidth / 2);
    return (w, y) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (i(), c("title", p, d(t.flagName), 1)) : h("", !0),
        k,
        v,
        g,
        z
      ]),
      e("g", H, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  B as default
};
//# sourceMappingURL=tj-65bf2a49.js.map
